import { actions } from 'data'
import { Bank } from 'data/Payments/BankTransfer/types'
import messages from 'lang'
import { MessageDescriptor } from 'react-intl'

type SettlementResponseReturnType = {
  bank: Bank
  message?: MessageDescriptor
  returnedAction: any
  settlementResponse: any
}

const addSettlementResponseToState = (
  settlementResponse: any,
  message: MessageDescriptor,
  bank: Bank
) => {
  return { bank, message, returnedAction: actions.payments.setBankSettlement, settlementResponse }
}

const switchSettlementReason = (settlementResponse: any, bank: Bank) => {
  switch (settlementResponse.reason) {
    case 'REQUIRES_UPDATE':
      return addSettlementResponseToState(
        settlementResponse,
        settlementResponse.settlementType === 'UNAVAILABLE'
          ? messages.bank_settlement_unavailable_requires_update
          : messages.bank_settlement_regular_requires_update,
        bank
      )
    case 'INSUFFICIENT_BALANCE':
      return addSettlementResponseToState(
        settlementResponse,
        settlementResponse.settlementType === 'UNAVAILABLE'
          ? messages.bank_settlement_unavailable_insufficient_msg
          : messages.bank_settlement_regular_insufficient_msg,
        bank
      )
    case 'STALE_BALANCE':
      return addSettlementResponseToState(
        settlementResponse,
        settlementResponse.settlementType === 'UNAVAILABLE'
          ? messages.bank_settlement_unavailable_stale_msg
          : messages.bank_settlement_regular_stale_msg,
        bank
      )
    case 'GENERIC':
      return addSettlementResponseToState(
        settlementResponse,
        settlementResponse.settlementType === 'UNAVAILABLE'
          ? messages.bank_settlement_unavailable_generic_msg
          : messages.bank_settlement_regular_generic_msg,
        bank
      )

    default:
      return addSettlementResponseToState(
        settlementResponse,
        settlementResponse.settlementType === 'UNAVAILABLE'
          ? messages.bank_settlement_unavailable_generic_msg
          : messages.bank_settlement_regular_generic_msg,
        bank
      )
  }
}

const getSettlementAction = (settlementResponse: any, bank: Bank): SettlementResponseReturnType => {
  switch (settlementResponse.settlementType) {
    case 'UNAVAILABLE':
      return settlementResponse.reason
        ? switchSettlementReason(settlementResponse, bank)
        : addSettlementResponseToState(
            settlementResponse,
            messages.bank_settlement_unavailable_generic_msg,
            bank
          )
    case 'REGULAR':
      return settlementResponse.reason
        ? switchSettlementReason(settlementResponse, bank)
        : {
            bank,
            returnedAction: actions.payments.submitDeposit.submitDeposit,
            settlementResponse
          }
    case 'INSTANT':
      return {
        bank,
        returnedAction: actions.payments.submitDeposit.submitDeposit,
        settlementResponse
      }
    default:
      return {
        bank,
        returnedAction: actions.payments.submitDeposit.submitDeposit,
        settlementResponse
      }
  }
}

export default getSettlementAction
